"use client";
import React from "react";
import { flippableCardLayouts } from "modules/common/model/models";
import {
  CardPreviewLoading,
  SizingOptions,
} from "modules/common/components/CardPreviewLoading";
import { cn } from "utils/utils";
import { RotateCwSquare } from "lucide-react";
import {
  AutocompleteGameCard,
  CommonPagedCard,
  GameCard,
} from "modules/cards/model/card";
import { CollectionCard } from "modules/collections/details/model/collection";
import { DeckCardData } from "modules/decks/model/deck";
import { TradeItem } from "modules/tradeLists/model/tradeList";
import { CardPreviewSizing } from "utils/styles";
import { TradeCard } from "modules/swap-calculator/model/tradeCard";
import { ProposalItem } from "modules/trade-proposals/model/tradeProposal";
import { ImageProps } from "next/image";

interface Props
  extends Pick<ImageProps, "fetchPriority" | "priority" | "loading"> {
  card:
    | GameCard
    | AutocompleteGameCard
    | CollectionCard
    | DeckCardData
    | TradeItem
    | TradeCard
    | CommonPagedCard
    | ProposalItem;
  flipped: boolean;
  setFlipped: (flipped: boolean) => void;
  isFoil?: boolean;
  isTooltip?: boolean;
  sizing?: SizingOptions;
}

const FlipButton = ({
  setFlipped,
  flipped,
}: {
  setFlipped: (flipped: boolean) => void;
  flipped: boolean;
}) => (
  <div className="mt-4 flex justify-center">
    <button
      onClick={() => setFlipped(!flipped)}
      className="btn btn-outline btn-primary btn-sm"
    >
      <RotateCwSquare
        className={cn(
          "size-5 transition-transform duration-200",
          flipped ? "rotate-180" : ""
        )}
      />
      Flip
    </button>
  </div>
);

export const CardMediaImage = ({
  card,
  flipped,
  setFlipped,
  isFoil,
  isTooltip,
  sizing = CardPreviewSizing,
  ...imageProps
}: Props) => {
  const showButton =
    "features" in card &&
    "layout" in card.features &&
    "otherFaces" in card.features &&
    !!card.features.layout &&
    !isTooltip &&
    flippableCardLayouts.includes(card.features.layout) &&
    card.features.otherFaces;
  return (
    <div className="flex w-full flex-col">
      <div
        className={`transform-3d relative transition-transform duration-200 ${
          flipped ? "[transform:rotateY(180deg)]" : ""
        }`}
      >
        <div className="backface-hidden flex items-center justify-center">
          <CardPreviewLoading
            card={card}
            foil={isFoil}
            isBack={false}
            sizing={sizing}
            {...imageProps}
          />
        </div>
        {"features" in card &&
          "layout" in card.features &&
          "otherFaces" in card.features &&
          !!card.features.layout &&
          flippableCardLayouts.includes(card.features.layout) &&
          card.features.otherFaces && (
            <div className="backface-hidden absolute left-0 top-0 h-full w-full [transform:rotateY(180deg)]">
              <CardPreviewLoading
                card={card}
                foil={isFoil}
                isBack={true}
                sizing={sizing}
              />
            </div>
          )}
      </div>
      {showButton && <FlipButton setFlipped={setFlipped} flipped={flipped} />}
    </div>
  );
};
